var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-light mb-3",attrs:{"type":"button"},on:{"click":function($event){return _vm.goBack()}}},[_c('font-awesome-icon',{attrs:{"icon":"fa fa-arrow-left"}}),_vm._v(" "+_vm._s(_vm.$t('Cancel'))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }